export const markerX = 85;
export const markerY = 70;
export const regularMarkerX = 30;
export const regularMarkerY = 30;
export const activeMarkerX = 48;
export const activeMarkerY = 60;
